<div [class]="class">
    <div class="flexCenter">
        <mat-spinner></mat-spinner>
    </div>
    <br/>
    <p *ngIf="showText && !habilitar" class="headline5">{{'planes.process.loading.title' | translate}}</p>
    <p *ngIf="showText && habilitar" class="headline5">{{'planes.process.loading.titleHabilitar' | translate}}</p>
    <p *ngIf="showText" class="subtitle1">{{'planes.process.loading.text' | translate}}</p>
    <br/>
</div>